"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  width: ", ";\n  height: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: ", ";\n  background: ", ";\n  color: white;\n  svg {\n    display: block;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding-bottom: 56.25%;\n  border-radius: ", ";\n  overflow: hidden;\n  transform: translateZ(0); // Safari fix.\n  background-image: linear-gradient(\n    146deg,\n    ", " 8%,\n    ", " 100%\n  );\n  > div {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    padding: ", ";\n    align-items: center;\n    justify-content: center;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  > ", ":not(:first-child) {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    animation: ", " 0.25s linear;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  border-radius: ", ";\n  overflow: hidden;\n  transform: translateZ(0); // Safari fix\n  position: relative;\n  background: ", ";\n  &::before {\n    display: block;\n    content: ' ';\n    padding-bottom: 56.25%;\n    width: 100%;\n  }\n  > div {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    > img {\n      margin: 0 auto;\n      max-width: 100%;\n      max-height: 100%;\n      display: block;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconContainer = exports.ImagePlaceholder = exports.ImageContainer = exports.GridImage = void 0;

var icons_1 = require("@ant-design/icons");

var web_1 = require("@thesisedu/web");

var react_1 = __importDefault(require("react"));

var styled_components_1 = require("styled-components");

function GridImage(_ref) {
  var src = _ref.src,
      alt = _ref.alt;
  var loadState = (0, web_1.useImageLoad)(src);

  var _react_1$default$useS = react_1.default.useState(true),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      includePlaceholder = _react_1$default$useS2[0],
      setIncludePlaceholder = _react_1$default$useS2[1];

  var shouldAnimateRef = react_1.default.useRef(false); // If the image loads before 250ms have passed, show it immediately, without animating.

  react_1.default.useEffect(function () {
    var interval = setTimeout(function () {
      shouldAnimateRef.current = true;
    }, 250);
    return function () {
      return clearInterval(interval);
    };
  }, []);
  react_1.default.useEffect(function () {
    if (loadState === web_1.ImageLoadResult.Loaded) {
      if (shouldAnimateRef.current) {
        setTimeout(function () {
          setIncludePlaceholder(false);
        }, 250);
      } else {
        setIncludePlaceholder(false);
      }
    }
  }, [loadState]);
  return react_1.default.createElement(LoadContainer, null, includePlaceholder ? react_1.default.createElement(ImagePlaceholder, null, react_1.default.createElement(exports.IconContainer, {
    background: loadState === web_1.ImageLoadResult.Error ? '@orange' : undefined
  }, loadState === web_1.ImageLoadResult.Error ? react_1.default.createElement(icons_1.ExclamationCircleOutlined, null) : react_1.default.createElement(icons_1.LoadingOutlined, null))) : null, loadState === web_1.ImageLoadResult.Loaded ? react_1.default.createElement(exports.ImageContainer, null, react_1.default.createElement("div", null, react_1.default.createElement("img", {
    src: src,
    alt: alt
  }))) : null);
}

exports.GridImage = GridImage;
var FadeIn = (0, styled_components_1.keyframes)(_templateObject());
exports.ImageContainer = web_1.styled.div(_templateObject2(), function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@gray-7'];
});
var LoadContainer = web_1.styled.div(_templateObject3(), exports.ImageContainer, FadeIn);

function ImagePlaceholder(_a) {
  var children = _a.children,
      containerStyle = _a.containerStyle,
      props = __rest(_a, ["children", "containerStyle"]);

  return react_1.default.createElement(_ImagePlaceholder, Object.assign({}, props), react_1.default.createElement("div", {
    style: containerStyle
  }, children));
}

exports.ImagePlaceholder = ImagePlaceholder;

var _ImagePlaceholder = web_1.styled.div(_templateObject4(), function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@gray-1'];
}, function (props) {
  return props.theme['@gray-2'];
}, function (props) {
  return props.theme['@size-l'];
});

exports.IconContainer = web_1.styled.div(_templateObject5(), function (props) {
  return props.theme['@gray-5'];
}, function (props) {
  return props.theme['@size-l'];
}, function (props) {
  return props.theme['@size-xxl'];
}, function (props) {
  return props.theme['@size-xxl'];
}, function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme[props.background || '@gray-5'];
});